<template>
  <div v-if="fileIsTooBig" class="file-viewer file-too-big">
    {{  $t('dragAndDropContainer.fileTooBigForPreview')  }}
  </div>
  <div v-else class="file-viewer">
    <component
        :documentId="uniqueDOMuid"
        :is="getComponent"
        :pdfFile="file"
        :imageFile="file"
        v-if="file"
    />
  </div>
</template>

<script>
import PdfViewer from "@/components/filemanager/PdfViewer";
import ImageViewer from "@/components/filemanager/ImageViewer";
import {renderComponent} from "@/mixins/renderComponent";
export default {
  name: "FileViewer",
  components: {ImageViewer, PdfViewer},
  props: ['file'],
  mixins: [renderComponent],
  computed: {
    getComponent() {
      if(this.file && this.file.type === 'application/pdf') {
        return 'PdfViewer';
      } else if (this.file) {
        return 'ImageViewer';
      }else {
        return '';
      }
    },
    fileIsTooBig() {
      return this.file && this.file.size && this.file.size > 1992294 && typeof this.file.url !== 'string';
    }
  }
}
</script>

<style scoped>
.file-viewer, .file-viewer > div {
  height: 100%;
  max-height: unset;
  background-color: lightgray;
}
</style>